import { KeyboardEvent, useCallback } from "react";
import keyCodes from "../constants/keyCodes";
import keyNames from "../constants/keyNames";

export function shouldSubmit(e: KeyboardEvent, multiline: boolean) {
  const enterKey = e.which === keyCodes.enter || [e.key, e.code].includes(keyNames.enter);
  return multiline ? enterKey && e.metaKey : enterKey;
}

export default function useSubmitTextKeys(multiline: boolean) {
  return useCallback(
    (e: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (shouldSubmit(e, multiline)) {
        e.preventDefault();
        e.currentTarget.blur();
      }
    },
    [multiline]
  );
}
